/* eslint-disable react/sort-comp */
import React, { Fragment, Component } from 'react';
import { Input, Icon } from 'semantic-ui-react';
import { get } from 'lodash';
import { withLocalize } from 'react-localize-redux';
import { graphql } from 'react-apollo';
import { compose } from 'recompose';
import styled from 'styled-components';
import { CHECK_EVENT_SLUG } from '../../events/graphql';

import ErrorMessage from './errorMessage';
import { hlog } from '../../common/util';

const CheckSlugLabel = styled.a`
  font-size: 18px;
  line-height: 21.6px;
  font-weight: 700;
  color: #0F70BC;
  padding-top: 8px;
  padding-left: 20px;
`;

const Container = styled.div`
  display: flex;
`;

class HHSlug extends Component {
  state = { slugCheckSuccess: false };

  render() {
    const {
      field,
      form: { touched, errors, setErrors },
      otherProps,
      translate,
      checkEventSlug
    } = this.props;
    const { slugCheckSuccess } = this.state;
    const hasError = !!(touched[field.name] && errors[field.name]);

    const actionLabel = slugCheckSuccess && !hasError
      ? { icon: <Icon name='check circle' color='green' /> }
      : null;

    const onChange = (e) => {
      field.onChange(e);
      this.setState({ slugCheckSuccess: false });
    };

    return (
      <Fragment>
        <Container>
          <Input
            type='text'
            {...field}
            {...otherProps}
            error={hasError}
            onChange={onChange}
            {...actionLabel}
          />
          {!slugCheckSuccess &&
            <CheckSlugLabel
              data-cy-test-id='checkDuplicateSlugBtn'
              onClick={() => {
                const slug = field.value;
                checkEventSlug({ variables: { slug } })
                  .then((res) => {
                    const taken = get(res, 'data.checkEventSlug.status');
                    if (taken) {
                      setErrors({ slug: translate('form.error.async.slugTaken') });
                    } else {
                      this.setState({ slugCheckSuccess: true });
                    }
                  })
                  .catch(err => { hlog(err); });
              }}
            >
              {translate('button.check')}
            </CheckSlugLabel>
          }
        </Container>
        {hasError && (<ErrorMessage error={errors[field.name]} />)}
      </Fragment>
    );
  }
}

export default compose(
  graphql(CHECK_EVENT_SLUG, { name: 'checkEventSlug' }),
  withLocalize,
)(HHSlug);



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhSlug.js